// Pure check: bestaat er minstens één compleet pad
// Stakeholder → Activity → Effect in deze TOC-data?
//
// Een pad is compleet als:
//   - er een Effect bestaat met `Activity` array (zie OutputEffect.Activity[]
//     gevuld in src/components/effects/SelectActivities.jsx)
//   - die Activity-array bevat een Activity-ID die naar een bestaande Activity
//     verwijst
//   - die Activity heeft een `Targetgroup` array (zie Activity.Targetgroup[]
//     gevuld in src/components/activities/SelectTargetgroup.jsx)
//   - die Targetgroup-array bevat een Stakeholder-ID die naar een bestaande
//     Stakeholder verwijst
//
// Note: link-arrays gebruiken `ID` (niet docid) als referentie — zelfde
// patroon als de UI-componenten.
//
// Returnt:
//   { hasCompleteChain: boolean, missing: { stakeholders?, activities?, effects?: true } }
//
// LET OP: er zijn twee ketendefinities, met opzet. Deze toetst doelgroep →
// activiteit → effect en slaat het mechanisme over ("mag de TOC-banner weg").
// functions/portfolio/buildTocOverview.js eist het mechanisme wél als schakel
// (kolom KOPPELINGEN in het beheertenant-projectenoverzicht, besluit
// 2026-08-31), en komt dus lager uit. Verander er geen van beide zonder de
// ander te benoemen; zie docs/database.md bij TocMechanisms.
//
// Spec: docs/features/onboarding-flow.md sectie "AI TOC-strategie".

const hasCompleteTOCChain = (input) => {

    const safe = input || {}
    const stakeholders = Array.isArray(safe.stakeholders) ? safe.stakeholders : []
    const activities = Array.isArray(safe.activities) ? safe.activities : []
    const effects = Array.isArray(safe.effects) ? safe.effects : []

    const missing = {}
    if (stakeholders.length === 0) missing.stakeholders = true
    if (activities.length === 0) missing.activities = true
    if (effects.length === 0) missing.effects = true

    if (Object.keys(missing).length > 0) {
        return { hasCompleteChain: false, missing }
    }

    const stakeholderIds = new Set(stakeholders.map((s) => s.ID).filter(Boolean))
    const activitiesById = new Map()
    activities.forEach((a) => {
        if (a && a.ID) activitiesById.set(a.ID, a)
    })

    // Probeer minstens één effect te vinden dat een geldig pad voltooit
    const completeEffect = effects.find((eff) => {

        if (!eff) return false

        // Effect moet minimaal één activiteit gekoppeld hebben
        const linkedActivityIds = Array.isArray(eff.Activity) ? eff.Activity : []
        if (linkedActivityIds.length === 0) return false

        // Voor minstens één gekoppelde activiteit: die moet bestaan + een
        // gekoppelde doelgroep hebben die ook bestaat.
        return linkedActivityIds.some((activityId) => {
            const activity = activitiesById.get(activityId)
            if (!activity) return false

            const linkedTargetgroupIds = Array.isArray(activity.Targetgroup) ? activity.Targetgroup : []
            if (linkedTargetgroupIds.length === 0) return false

            return linkedTargetgroupIds.some((stakeholderId) => stakeholderIds.has(stakeholderId))
        })
    })

    if (completeEffect) {
        return { hasCompleteChain: true, missing: {} }
    }

    return { hasCompleteChain: false, missing: {} }

}

export default hasCompleteTOCChain
